// create function who retourn pagesetting or embedsetting according if it's an embed or not and if there are pagesetting or not
export const getBrandSettingType = (content, isEmbed) =>
  isEmbed ? content?.embedSetting : content?.pageSetting;
